// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"272aac2c","498":"4515f12a","703":"2aef5526","787":"d04f89e9"}[chunkId] + ".chunk.js";
};